import { forwardRef } from 'react';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  input: {
    minWidth: '180px',
    width: '100%',
    height: '32px',
    minHeight: '32px',
    maxHeight: '32px',
    display: 'block',
    flex: '0 0 auto',
    alignSelf: 'stretch',
    paddingTop: '0',
    paddingBottom: '0',
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: '36px',
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    fontFamily: tokens.fontFamilyBase,
    lineHeight: tokens.lineHeightBase300,
    boxSizing: 'border-box',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    outlineStyle: 'none',
    overflow: 'hidden',
    verticalAlign: 'middle',
    selectors: {
      '&::-webkit-calendar-picker-indicator': {
        margin: 0,
        padding: 0,
        width: '16px',
        height: '16px',
      },
      '&::-webkit-datetime-edit': {
        padding: 0,
        lineHeight: tokens.lineHeightBase300,
      },
      '&::-webkit-datetime-edit-fields-wrapper': {
        padding: 0,
        lineHeight: tokens.lineHeightBase300,
      },
      '&::-webkit-datetime-edit-text': {
        padding: '0 2px',
      },
      '&::-webkit-date-and-time-value': {
        minHeight: '20px',
        lineHeight: tokens.lineHeightBase300,
      },
      '&::-webkit-datetime-edit-month-field': {
        padding: 0,
      },
      '&::-webkit-datetime-edit-day-field': {
        padding: 0,
      },
      '&::-webkit-datetime-edit-year-field': {
        padding: 0,
      },
    },
  },
});

interface NativeDateInputProps {
  value: string;
  min?: string;
  max?: string;
  onChange: (value: string) => void;
  className?: string;
}

export const NativeDateInput = forwardRef<HTMLInputElement, NativeDateInputProps>(
  function NativeDateInput({ value, min, max, onChange, className }, ref) {
    const styles = useStyles();

    return (
      <input
        ref={ref}
        type="date"
        value={value}
        min={min}
        max={max}
        onChange={(event) => onChange(event.target.value)}
        onClick={(event) => event.currentTarget.showPicker?.()}
        onFocus={(event) => event.currentTarget.showPicker?.()}
        className={mergeClasses(styles.input, className)}
      />
    );
  }
);
